export default {
    '1d-diagram2': {
        'diagram-task': 'Type your answer in the white box.<br>Then click the ‘reveal’ button to see how it compares to the correct answer',
      'diagram-description': `<li>Most traditional ERM models are overly complex</li>
                                <li>Modelers have a pent-up capability they are itching to unleash</li>
                                <li>Modelers are misguided in perfecting their models</li>
                                <li>Traditional ERM models do not support decision making</li>`,
      'diagram-description2': `<li>Value-based models are not overly complex</li>
                                <li>Value-based ERM models balance robustness and practicality</li>
                                <li>Value-based models have a single focus</li>
                                <li>Value-based models are designed to link risk management to business</li>`,
        'fixed-answer1': 'Traditional ERM models do not support decision making',
        'fixed-answer2': 'Value-based ERM models balance robustness and practicality',
        'fixed-answer3': 'Overly complex design',
        'fixed-answer4': 'Overly detailed execution',
        'fixed-answer5': 'Designed with a single focus in mind',
        'fixed-answer6': 'Tailored to be sleek and practical',
        'complete-title': 'Reveal',
        'hide-title': 'Hide',
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/1/1d/diagram2/i18n/en.js